/* ============================================
   GIGLIOTTO TENUTE — Booking Widget + Qty
   Only loaded on degustazioni-booking.liquid
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  initQuantitySelectors();
  initBookingWidget();
});

function initQuantitySelectors() {
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-selector')?.querySelector('input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'plus')               val++;
      if (btn.dataset.action === 'minus' && val > 1)   val--;
      input.value = val;
    });
  });
}

function initBookingWidget() {
  const widget = document.querySelector('.booking-widget');
  if (!widget) return;

  const state = { variantId: null, pricePerPerson: 0, title: '', guests: 0, date: '', time: '' };

  const panels      = widget.querySelectorAll('.booking-panel');
  const steps       = widget.querySelectorAll('.booking-step');
  const packages    = widget.querySelectorAll('.booking-package');
  const dateInput   = widget.querySelector('#booking-date');
  const timeInput   = widget.querySelector('#booking-time');
  const guestBtns   = widget.querySelectorAll('.booking-guests-btn');
  const guestsVal   = widget.querySelector('#booking-guests-value');
  const guestsNote  = widget.querySelector('#booking-guests-note');
  const pricePreview = widget.querySelector('#booking-price-preview');
  const priceTotal   = widget.querySelector('#booking-price-total');
  const summaryTop   = widget.querySelector('#booking-summary-top');
  const recap        = widget.querySelector('#booking-recap');
  const btn1  = widget.querySelector('#btn-step-1');
  const btn2  = widget.querySelector('#btn-step-2');
  const btnB1 = widget.querySelector('#btn-back-1');
  const btnB2 = widget.querySelector('#btn-back-2');

  const locale = document.documentElement.lang || 'it-IT';

  if (dateInput) {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    dateInput.min = tomorrow.toISOString().split('T')[0];
  }

  function goToStep(n) {
    panels.forEach((p, i) => p.classList.toggle('active', i === n - 1));
    steps.forEach((s, i) => {
      s.classList.toggle('active', i === n - 1);
      s.classList.toggle('completed', i < n - 1);
    });
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function updatePricePreview() {
    if (!state.guests || !state.pricePerPerson) { if (pricePreview) pricePreview.style.display = 'none'; return; }
    const guests = state.guests === 'group' ? 10 : state.guests;
    const total  = state.pricePerPerson * guests;
    if (priceTotal) priceTotal.textContent = state.guests === 'group' ? formatMoney(total) + '+' : formatMoney(total);
    if (pricePreview) pricePreview.style.display = 'flex';
  }

  function checkStep2Valid() {
    if (btn2) btn2.disabled = !(state.date && state.time && state.guests);
  }

  packages.forEach(pkg => {
    pkg.addEventListener('click', () => {
      packages.forEach(p => p.classList.remove('selected'));
      pkg.classList.add('selected');
      const radio = pkg.querySelector('.booking-package__radio');
      if (radio) radio.checked = true;
      state.variantId      = pkg.dataset.productId;
      state.pricePerPerson = parseInt(pkg.dataset.price, 10) || 0;
      state.title          = pkg.dataset.title;
      if (btn1) btn1.disabled = false;
    });
  });

  btn1?.addEventListener('click', () => {
    if (!state.variantId) return;
    if (summaryTop) summaryTop.innerHTML = `✓ ${state.title} — ${formatMoney(state.pricePerPerson)} ${window.bookingStrings?.per_person || ''}`;
    goToStep(2);
  });

  dateInput?.addEventListener('change', () => { state.date = dateInput.value; checkStep2Valid(); });
  timeInput?.addEventListener('change', () => { state.time = timeInput.value; checkStep2Valid(); });

  guestBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      guestBtns.forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      const val = btn.dataset.value;
      state.guests = val === '0' ? 'group' : parseInt(val, 10);
      if (guestsNote) guestsNote.style.display = val === '0' ? 'block' : 'none';
      if (guestsVal)  guestsVal.value = val === '0' ? '10+' : val;
      updatePricePreview();
      checkStep2Valid();
    });
  });

  btn2?.addEventListener('click', () => {
    if (!state.date || !state.time || !state.guests) return;

    const guestsNum = state.guests === 'group' ? 10 : state.guests;
    const totalCents = state.pricePerPerson * guestsNum;
    const dateFormatted = new Date(state.date + 'T12:00:00').toLocaleDateString(locale, {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
    });
    const s = window.bookingStrings || {};
    const guestsLabel = state.guests === 'group'
      ? '10+ ' + (s.guests_unit || 'guests')
      : guestsNum + ' ' + (s.guests_unit || 'guests');

    if (recap) recap.innerHTML = `
      <div class="booking-recap__row"><span class="booking-recap__label">${s.step1_label || ''}</span><span class="booking-recap__value">${state.title}</span></div>
      <div class="booking-recap__row"><span class="booking-recap__label">${s.date || ''}</span><span class="booking-recap__value">${dateFormatted}</span></div>
      <div class="booking-recap__row"><span class="booking-recap__label">${s.time || ''}</span><span class="booking-recap__value">${state.time}</span></div>
      <div class="booking-recap__row"><span class="booking-recap__label">${s.guests_required?.replace(' *','') || ''}</span><span class="booking-recap__value">${guestsLabel}</span></div>
      <div class="booking-recap__row"><span class="booking-recap__label">${s.price_per_person || ''}</span><span class="booking-recap__value">${formatMoney(state.pricePerPerson)}</span></div>
      ${state.guests !== 'group'
        ? `<div class="booking-recap__total"><span class="booking-recap__total-label">${s.total_label || ''}</span><span class="booking-recap__total-amount">${formatMoney(totalCents)}</span></div>`
        : `<p style="margin-top:1rem;font-size:0.85rem;color:var(--color-text-muted)">${s.group_note || ''}</p>`
      }`;

    widget.querySelector('#booking-variant-id').value = state.variantId;
    widget.querySelector('#booking-quantity').value   = guestsNum;
    widget.querySelector('#prop-date').value   = dateFormatted;
    widget.querySelector('#prop-time').value   = state.time;
    widget.querySelector('#prop-guests').value = guestsLabel;

    goToStep(3);
  });

  btnB1?.addEventListener('click', () => goToStep(1));
  btnB2?.addEventListener('click', () => goToStep(2));

  const cartForm = widget.querySelector('#booking-cart-form');
  const payBtn   = widget.querySelector('#btn-pay');
  cartForm?.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (payBtn) {
      payBtn.disabled = true;
      payBtn.textContent = window.bookingStrings?.processing || '...';
    }
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(cartForm) });
      if (!res.ok) throw new Error('cart_error');
      window.location.href = '/checkout';
    } catch {
      if (payBtn) {
        payBtn.disabled = false;
        payBtn.textContent = window.bookingStrings?.confirm_pay || 'Confirm & Pay';
      }
      alert(window.cartStrings?.error || 'Error');
    }
  });
}
